document.addEventListener('DOMContentLoaded', function () {
    // Dein bestehender Subnav-/Sticky-Code
    var subnavWrapper = document.getElementById('subnav');
    if (subnavWrapper) {
        var subnav = document.getElementById('subnav');
        if (subnav) {
            var height = subnav.offsetHeight;
            document.documentElement.style.setProperty('--subnav-height', height + 'px');
        }

        var sentinel = document.createElement('div');
        sentinel.id = 'subnav_sentinel';
        subnavWrapper.parentNode.insertBefore(sentinel, subnavWrapper);

        var observer = new IntersectionObserver(function (entries) {
            var entry = entries[0];
            if (entry.intersectionRatio === 0) {
                subnavWrapper.classList.add('is-sticky');
            } else {
                subnavWrapper.classList.remove('is-sticky');
            }
        }, {
            threshold: [0]
        });

        observer.observe(sentinel);
    }

    // NEU: Höhe der zugehörigen Überschrift für jedes .scrollto ermitteln
    var scrolltos = document.querySelectorAll('.scrollto');

    scrolltos.forEach(function (scrollto) {
        // vorheriges Geschwister-Element (Überschrift) holen
        var heading = scrollto.previousElementSibling;

        // Sicherstellen, dass es wirklich ein H1–H6 ist
        if (heading && /^H[1-6]$/.test(heading.tagName)) {
            var headingHeight = heading.offsetHeight;

            // CSS-Custom-Property direkt am scrollto-Div setzen
            scrollto.style.setProperty('--scrollto-headingheight', headingHeight + 'px');
        }
    });




    // NEU: Scrollspy / aktiven Nav-Button markieren
var navLinks = document.querySelectorAll('#subnav .subnav_headings a[href*="#"]');

if (scrolltos.length && navLinks.length) {

  var activeId = null;

  var sectionObserver = new IntersectionObserver(function (entries) {
    // Alle aktuell sichtbaren Sections sammeln
    var visibleSections = [];

    entries.forEach(function (entry) {
      if (!entry.target.id) return;

      // Wir interessieren uns nur für Einträge, die mindestens ein bisschen sichtbar sind
      if (entry.isIntersecting) {
        var rect = entry.target.getBoundingClientRect();
        visibleSections.push({
          id: entry.target.id,
          top: rect.top
        });
      }
    });

    // Reset, falls wir ganz oben sind oder nichts sichtbar ist
    if (visibleSections.length === 0) {
      if (window.scrollY < 50) { // "oben" Heuristik
        navLinks.forEach(function (l) {
          l.classList.remove('is-active');
        });
        activeId = null;
      }
      return;
    }

    // Die Section wählen, die dem oberen Viewport-Rand am nächsten ist
    visibleSections.sort(function (a, b) {
      return a.top - b.top;
    });

    var newActiveId = visibleSections[0].id;

    if (newActiveId === activeId) {
      // Nichts geändert – keine Umschaltung nötig
      return;
    }

    activeId = newActiveId;

    // Alle Links zurücksetzen
    navLinks.forEach(function (l) {
      l.classList.remove('is-active');
    });

    // Passenden Link aktiv setzen
    var selector = '#subnav .subnav_headings a[href$="#' + CSS.escape(newActiveId) + '"]';
    var activeLink = document.querySelector(selector);
    if (activeLink) {
      activeLink.classList.add('is-active');
    }

  }, {
    threshold: 0.1 // klein halten, damit Section früh als sichtbar gilt
    // rootMargin kannst du optional anpassen, z.B. um den "Aktivbereich" zu verschieben
    // rootMargin: '-10% 0px -70% 0px'
  });

  scrolltos.forEach(function (scrollto) {
    sectionObserver.observe(scrollto);
  });
}


});
